export default __webpack_public_path__ + "static/media/signup_2.233631e9.jpg";